import { Instance, types } from 'mobx-state-tree'
import '../../ieConfig/MobxConfig'
import { Subscription } from './Subscription'

const UPI = types.model('UPI', {
  id: types.number,
  name: types.optional(types.string, ''),
  vpa: types.optional(types.string, ''),
  balance: types.optional(types.string, ''),
  logo: types.optional(types.string, ''),
  isSave: types.optional(types.boolean, false),
  isSubscription: types.optional(types.boolean, false),
  subscription: types.optional(Subscription, {}),
  paymentType: types.optional(types.string, 'UPI'),
  instrumentId: types.optional(types.union(types.number, types.string), ''),
})

export type UPIType = Instance<typeof UPI>
export { UPI }
